import i18n from './../../shared/i18n';
import BaseModel from "../../core/components/input-widget/BaseModel";

export default class NewRelationModel extends BaseModel {
  uuid = null;
  object_uuid = null;
  type = null;
  type_text = null;
  related_customer_uuid = null;
  note = null;
  including_vat = false;
  taxable = false;
  confirmations = false;
  suggestions = false;
  settlements = false;
  cc = false;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    related_customer_uuid: 'required',
    type: 'required',
    type_text: 'required',
    intermediary_flat_price: 'min_value:0.01'
  };

  attributeLabels = {
    related_customer_uuid: i18n.t('Related Customer'),
    intermediary_commission_rate: i18n.t('Intermediary Commission Rate'),
    beneficiary_rate: i18n.t('Beneficiary Rate'),
    intermediary_commission_from: i18n.t('Calculate From'),
    including_vat: i18n.t('Including Vat'),
    note: i18n.t('Note'),
    type: i18n.t('Type'),
    type_text: i18n.t('Other Type'),
    confirmations: i18n.t('Receipts'),
    suggestions: i18n.t('Pre/Post Sales'),
    settlements: i18n.t('Settlements'),
    cc: i18n.t('Remove from CC'),
    taxable: i18n.t('Taxable'),
    intermediary_flat_price: i18n.t('Flat Price'),
  };

  toJSON() {
    return super.toJSON()
  }
}
